import { Box, Flex, Input } from "@chakra-ui/react";
import { Typography } from "@reconvert/react-ui-component";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface ProductTitleSelectorProps {
  titleText: string;
  value: string;
  setTitleValue: (data: { value: string }) => void;
  placeholder?: string;
  isWhiteSpaceAllowed?: boolean;
  warningMessage?: string;
}

const ProductTextSelector = ({ titleText, value, setTitleValue, placeholder, isWhiteSpaceAllowed, warningMessage }: ProductTitleSelectorProps) => {
  const { t } = useTranslation();
  const [showWarning, setShowWarning] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    if (isWhiteSpaceAllowed === false && /\s/.test(inputValue)) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
    
    setTitleValue({ value: inputValue });
  };

  return (
    <Box mt={2}>
      <Flex gap={1} flexDirection={"column"}>
        <Typography color={"#6A7381"} width={"max-content"} bg={"var(--Natural-100, #F9FAFC)"} variant="small">
          {t(titleText)}
        </Typography>
        <Input 
          value={value} 
          onChange={handleInputChange} 
          placeholder={placeholder}
          borderColor={showWarning ? "red.500" : undefined}
        />
        {showWarning && (
          <Typography color={"red.500"} variant="small">
            {warningMessage}
          </Typography>
        )}
      </Flex>
    </Box>
  );
};

export default ProductTextSelector;
